import { createFrontendModule } from '@backstage/frontend-plugin-api';

import {
  HomeExtension,
} from './extensions';

export const ipenHomeModule = createFrontendModule({
  extensions: [
    HomeExtension,
  ],
  pluginId: 'home',
});
